/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SyncRouteImport } from './routes/sync'
import { Route as SplitsRouteImport } from './routes/splits'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as RulesRouteImport } from './routes/rules'
import { Route as PnlRouteImport } from './routes/pnl'
import { Route as ManualRouteImport } from './routes/manual'
import { Route as LoanSchedulesRouteImport } from './routes/loan-schedules'
import { Route as IssuesRouteImport } from './routes/issues'
import { Route as IndicatorsRouteImport } from './routes/indicators'
import { Route as EntriesRouteImport } from './routes/entries'
import { Route as CardsRouteImport } from './routes/cards'
import { Route as BalanceRouteImport } from './routes/balance'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SignInSplatRouteImport } from './routes/sign-in.$'

const SyncRoute = SyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => rootRouteImport,
} as any)
const SplitsRoute = SplitsRouteImport.update({
  id: '/splits',
  path: '/splits',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const RulesRoute = RulesRouteImport.update({
  id: '/rules',
  path: '/rules',
  getParentRoute: () => rootRouteImport,
} as any)
const PnlRoute = PnlRouteImport.update({
  id: '/pnl',
  path: '/pnl',
  getParentRoute: () => rootRouteImport,
} as any)
const ManualRoute = ManualRouteImport.update({
  id: '/manual',
  path: '/manual',
  getParentRoute: () => rootRouteImport,
} as any)
const LoanSchedulesRoute = LoanSchedulesRouteImport.update({
  id: '/loan-schedules',
  path: '/loan-schedules',
  getParentRoute: () => rootRouteImport,
} as any)
const IssuesRoute = IssuesRouteImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => rootRouteImport,
} as any)
const IndicatorsRoute = IndicatorsRouteImport.update({
  id: '/indicators',
  path: '/indicators',
  getParentRoute: () => rootRouteImport,
} as any)
const EntriesRoute = EntriesRouteImport.update({
  id: '/entries',
  path: '/entries',
  getParentRoute: () => rootRouteImport,
} as any)
const CardsRoute = CardsRouteImport.update({
  id: '/cards',
  path: '/cards',
  getParentRoute: () => rootRouteImport,
} as any)
const BalanceRoute = BalanceRouteImport.update({
  id: '/balance',
  path: '/balance',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInSplatRoute = SignInSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => SignInRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/balance': typeof BalanceRoute
  '/cards': typeof CardsRoute
  '/entries': typeof EntriesRoute
  '/indicators': typeof IndicatorsRoute
  '/issues': typeof IssuesRoute
  '/loan-schedules': typeof LoanSchedulesRoute
  '/manual': typeof ManualRoute
  '/pnl': typeof PnlRoute
  '/rules': typeof RulesRoute
  '/sign-in': typeof SignInRouteWithChildren
  '/splits': typeof SplitsRoute
  '/sync': typeof SyncRoute
  '/sign-in/$': typeof SignInSplatRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/balance': typeof BalanceRoute
  '/cards': typeof CardsRoute
  '/entries': typeof EntriesRoute
  '/indicators': typeof IndicatorsRoute
  '/issues': typeof IssuesRoute
  '/loan-schedules': typeof LoanSchedulesRoute
  '/manual': typeof ManualRoute
  '/pnl': typeof PnlRoute
  '/rules': typeof RulesRoute
  '/sign-in': typeof SignInRouteWithChildren
  '/splits': typeof SplitsRoute
  '/sync': typeof SyncRoute
  '/sign-in/$': typeof SignInSplatRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/balance': typeof BalanceRoute
  '/cards': typeof CardsRoute
  '/entries': typeof EntriesRoute
  '/indicators': typeof IndicatorsRoute
  '/issues': typeof IssuesRoute
  '/loan-schedules': typeof LoanSchedulesRoute
  '/manual': typeof ManualRoute
  '/pnl': typeof PnlRoute
  '/rules': typeof RulesRoute
  '/sign-in': typeof SignInRouteWithChildren
  '/splits': typeof SplitsRoute
  '/sync': typeof SyncRoute
  '/sign-in/$': typeof SignInSplatRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/balance'
    | '/cards'
    | '/entries'
    | '/indicators'
    | '/issues'
    | '/loan-schedules'
    | '/manual'
    | '/pnl'
    | '/rules'
    | '/sign-in'
    | '/splits'
    | '/sync'
    | '/sign-in/$'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/balance'
    | '/cards'
    | '/entries'
    | '/indicators'
    | '/issues'
    | '/loan-schedules'
    | '/manual'
    | '/pnl'
    | '/rules'
    | '/sign-in'
    | '/splits'
    | '/sync'
    | '/sign-in/$'
  id:
    | '__root__'
    | '/'
    | '/balance'
    | '/cards'
    | '/entries'
    | '/indicators'
    | '/issues'
    | '/loan-schedules'
    | '/manual'
    | '/pnl'
    | '/rules'
    | '/sign-in'
    | '/splits'
    | '/sync'
    | '/sign-in/$'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  BalanceRoute: typeof BalanceRoute
  CardsRoute: typeof CardsRoute
  EntriesRoute: typeof EntriesRoute
  IndicatorsRoute: typeof IndicatorsRoute
  IssuesRoute: typeof IssuesRoute
  LoanSchedulesRoute: typeof LoanSchedulesRoute
  ManualRoute: typeof ManualRoute
  PnlRoute: typeof PnlRoute
  RulesRoute: typeof RulesRoute
  SignInRoute: typeof SignInRouteWithChildren
  SplitsRoute: typeof SplitsRoute
  SyncRoute: typeof SyncRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/sync': {
      id: '/sync'
      path: '/sync'
      fullPath: '/sync'
      preLoaderRoute: typeof SyncRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/splits': {
      id: '/splits'
      path: '/splits'
      fullPath: '/splits'
      preLoaderRoute: typeof SplitsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rules': {
      id: '/rules'
      path: '/rules'
      fullPath: '/rules'
      preLoaderRoute: typeof RulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pnl': {
      id: '/pnl'
      path: '/pnl'
      fullPath: '/pnl'
      preLoaderRoute: typeof PnlRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/manual': {
      id: '/manual'
      path: '/manual'
      fullPath: '/manual'
      preLoaderRoute: typeof ManualRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loan-schedules': {
      id: '/loan-schedules'
      path: '/loan-schedules'
      fullPath: '/loan-schedules'
      preLoaderRoute: typeof LoanSchedulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/issues': {
      id: '/issues'
      path: '/issues'
      fullPath: '/issues'
      preLoaderRoute: typeof IssuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/indicators': {
      id: '/indicators'
      path: '/indicators'
      fullPath: '/indicators'
      preLoaderRoute: typeof IndicatorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entries': {
      id: '/entries'
      path: '/entries'
      fullPath: '/entries'
      preLoaderRoute: typeof EntriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/cards': {
      id: '/cards'
      path: '/cards'
      fullPath: '/cards'
      preLoaderRoute: typeof CardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/balance': {
      id: '/balance'
      path: '/balance'
      fullPath: '/balance'
      preLoaderRoute: typeof BalanceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/$': {
      id: '/sign-in/$'
      path: '/$'
      fullPath: '/sign-in/$'
      preLoaderRoute: typeof SignInSplatRouteImport
      parentRoute: typeof SignInRoute
    }
  }
}

interface SignInRouteChildren {
  SignInSplatRoute: typeof SignInSplatRoute
}

const SignInRouteChildren: SignInRouteChildren = {
  SignInSplatRoute: SignInSplatRoute,
}

const SignInRouteWithChildren =
  SignInRoute._addFileChildren(SignInRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  BalanceRoute: BalanceRoute,
  CardsRoute: CardsRoute,
  EntriesRoute: EntriesRoute,
  IndicatorsRoute: IndicatorsRoute,
  IssuesRoute: IssuesRoute,
  LoanSchedulesRoute: LoanSchedulesRoute,
  ManualRoute: ManualRoute,
  PnlRoute: PnlRoute,
  RulesRoute: RulesRoute,
  SignInRoute: SignInRouteWithChildren,
  SplitsRoute: SplitsRoute,
  SyncRoute: SyncRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
